var calculateSizes = function calculateSizes(sizePercentages, collapsedFirstElement, collapsedLastElement, collapsedSize) {
  var nbChildren = sizePercentages.length;
  var splitterCorrection = (nbChildren - 1) * 5 / nbChildren;
  return sizePercentages.map(function (sizePercentage, index) {
    var sizePerc = sizePercentage;
    var sizePx = 0;
    var collapsed = index === 0 && collapsedFirstElement || index === nbChildren - 1 && collapsedLastElement; // collapsed panels are collapsedSize

    if (collapsed) {
      return "".concat(collapsedSize - splitterCorrection, "px");
    }

    if (index === 1 && collapsedFirstElement) {
      sizePerc += sizePercentages[0];
      sizePx -= collapsedSize;
    }

    if (index === nbChildren - 2 && collapsedLastElement) {
      sizePerc += sizePercentages[index + 1];
      sizePx -= collapsedSize;
    }

    return "calc(".concat(sizePerc, "% + ").concat(sizePx - splitterCorrection, "px)");
  });
};

export default calculateSizes;